module.exports = __webpack_public_path__ + "static/logo_vertical_metodologiaead-a28f9f5404472677f6a9b3ae20d04fe7.svg";